import React from "react";
import { Circle, CheckCircle2 } from "lucide-react";
import TopicPlanNote from "../../Syllabus/schedule/TopicPlanNote";
import { MaterialChips, RecordingLinks } from "./StudentSyllabusLinks";

/**
 * StudentTopicRow
 *
 * Read-only topic row inside a student syllabus day card.
 *
 * Props:
 *   - index            : Number  (0-based topic index)
 *   - topic            : Object  { name, status, recordings: [{ videoId, title } | { recordingUrl }] }
 *   - linkedMaterials  : Array   [{ _id, title, fileType, category }]
 *   - onPlayRecording  : Function(recording) — open a recording in the player
 */
const StudentTopicRow = ({ index, topic, linkedMaterials = [], onPlayRecording }) => {
  const isCompleted = topic.status === "completed";

  return (
    <div className={`ss-topic-row ${isCompleted ? "ss-topic-completed" : ""}`}>
      {/* Left: index + icon + name */}
      <div className="ss-topic-left">
        <span className="ss-topic-index">{index + 1}.</span>
        <span
          className={`ss-topic-icon ${
            isCompleted ? "ss-topic-done" : "ss-topic-pending"
          }`}
        >
          {isCompleted ? (
            <CheckCircle2 size={16} />
          ) : (
            <Circle size={16} />
          )}
        </span>
        <div className="ss-topic-content">
          <span className="ss-topic-name">{topic.name}<TopicPlanNote topic={topic} /></span>
          {linkedMaterials.length > 0 && (
            <div className="ss-topic-materials">
              <MaterialChips materials={linkedMaterials} />
            </div>
          )}
        </div>
      </div>

      {/* Right: recordings */}
      <div className="ss-topic-right">
        <RecordingLinks recordings={topic.recordings} onPlay={onPlayRecording} />
      </div>
    </div>
  );
};

export default StudentTopicRow;
